import React, { useEffect, useState, ReactNode, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SuggestionWidget from "../../../common/components/SuggestionWidget";
import ButtonCommon from "../../../common/components/ButtonCommon";
import InputTextForm from "../../../common/components-forms/InputTextForm";
import SelectGenders from "../../../common/components-forms/SelectGenders";
import SelectBodyArea from "../../../common/components-forms/SelectBodyArea";
import SelectFitType from "../../../common/components-forms/SelectFitType";
import SelectDropdownForm from "../../../common/components-forms/SelectDropdownForm";
import MultiselectDropdownForm from "../../../common/components-forms/MultiselectDropdownForm";
import ChipsControl from "../../../common/components/ChipsControl";
import { SizeGuideServices } from "../../../../services";

import { Col, Row } from "react-bootstrap";
import "./ProductEdit.css";
import { FormattedMessage, useIntl } from "react-intl";
import TooltipAlias from "../../../common/components/TooltipAlias";
import BlockContentControls from "../../../common/components/BlockContentControls";
import { Tag } from "primereact/tag";

const ProductEdit = (props: any) => {
  const { state } = useLocation();
  const [editedData, setEditedData] = useState(state);
  const [editedSizeGuideName, setEditedSizeGuideName] = useState(
    state.SizeGuide.Name || ""
  );
  const [editedPlatformCategoryName, setEditedPlatformCategoryName] =
    useState("");
  // state.PlatformCategory[0].Name || ""
  const [editedVariantsId, setEditedVariantsId] = useState(
    state.VariantsId ? state.VariantsId[0] : null
  );
  const [SizeGuides, setSizeGuides] = useState<any[]>();
  const [isLoadingSizeGuides, setIsLoadingSizeGuides] = useState(true);
  const [selectedSizes, setSelectedSizes] = useState<any[]>([]);
  const [SizesGuideSelect, setSizesGuideSelect] = useState<any[]>([]);
  const [selectedSizesNames, setSelectedSizesNames] = useState<any[]>([]);
  const [selectedChips, setSelectedChips] = useState([]); // Lift the state to the parent component
  const [SizeGuideSelected, setSizeGuideSelected] = useState<any>(null);
  const [productReferenceCode, setProductReferenceCode] = useState(
    state.ProductReference ? state.ProductReference : ""
  );
  const [otherReference, setOtherReference] = useState<string[]>(
    state.OtherReference && state.OtherReference.length > 0
      ? state.OtherReference
      : new Array<string>()
  );
  const [inputValue, setInputValue] = useState("");
  const [isClicked, setIsClicked] = useState(false);
  const divRef = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    setIsClicked(true);
  };

  const handleDocumentClick = (event: MouseEvent) => {
    if (divRef.current && !divRef.current.contains(event.target as Node)) {
      setIsClicked(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick);
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleInputsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setInputValue(value);
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const clipboardData = event.clipboardData;
    if (clipboardData) {
      const aliasReference = [...otherReference];

      const pastedText = clipboardData.getData("text/plain");

      let updatedData = pastedText; // Concatenate new data with existing data

      let elementsCopied = updatedData.split("\r\n");

      // Remove the last element if it's empty
      if (
        elementsCopied.length > 0 &&
        elementsCopied[elementsCopied.length - 1] === ""
      ) {
        elementsCopied.pop();
      }

      elementsCopied = elementsCopied.filter(Boolean); // Remove any empty elements

      elementsCopied.forEach((element) => {
        if (element.split("\t").length) {
          element.split("\t").forEach((item) => {
            if (item.split(",").length) {
              item.split(",").forEach((itemComma) => {
                if (itemComma) aliasReference.push(itemComma);
              });
            } else {
              if (item) aliasReference.push(item);
            }
          });
        } else {
          if (element) aliasReference.push(element);
        }
      });

      setOtherReference(aliasReference);

      // Reset the input after pasting
      setInputValue(""); // Set the input value to blank
    }
  };

  const renderInputs = () => {
    if (!otherReference) return null;

    // Split the pasted data into individual items
    let items = otherReference;

    // Filter items based on the inputValue
    let filteredItems = items.filter((item) =>
      item.toLowerCase().includes(inputValue.toLowerCase())
    );

    // Render a Tag for each filtered item
    return (
      <div className="tag-container">
        {filteredItems.map((item, index) => (
          <div key={index} className="tag-item">
            <Tag>
              <div className="flex align-items-center gap-2 editsizeguide-alias-tag">
                <span className="text-base">{item}</span>
                <i
                  className="pi pi-times text-xs"
                  onClick={() => handleTagDelete(index)}
                ></i>
              </div>
            </Tag>
          </div>
        ))}
      </div>
    );
  };

  const handleTagDelete = (indexToDelete: any) => {
    // Get a copy of the current items array
    let newItems = [...otherReference];

    // Remove the item at the specified index
    newItems.splice(indexToDelete, 1);

    // Update the state with the new data
    setOtherReference(newItems);
  };

  const intl = useIntl();

  useEffect(() => {
    (async () => {
      try {
        setIsLoadingSizeGuides(true);

        const getSizeGuides = await SizeGuideServices.GetSizesGuides();

        if (getSizeGuides && getSizeGuides.Status === 200) {
          setSizeGuides(getSizeGuides.Content);
        } else {
          setSizeGuides([]);
        }

        setIsLoadingSizeGuides(false);
      } catch (error) {
        console.log(error);

        setIsLoadingSizeGuides(false);
      }
    })();
  }, []);

  const navigate = useNavigate();

  // async function getSizeGuides() {
  //   try {
  //     setIsLoadingSizeGuides(true);

  //     const getSizeGuides = await SizeGuideServices.GetSizesGuides();

  //     if (getSizeGuides && getSizeGuides.Status === 200) {
  //       setSizeGuides(getSizeGuides.Content);
  //     } else {
  //       setSizeGuides([]);
  //     }

  //     setIsLoadingSizeGuides(false);
  //   } catch (error) {
  //     console.log(error);

  //     setIsLoadingSizeGuides(false);
  //   }
  // }

  const onSizesChange = (value: any) => {
    try {
      setSelectedChips(value ? value : []);
      const selectedOptions = value
        ? [].map.call(value, (elemento: any) => {
            return { Id: elemento.code, Name: elemento.name };
          })
        : [];
      setSelectedSizes(selectedOptions);
      setSelectedSizesNames(
        selectedOptions.map((elemento: any) => elemento.Name)
      );
    } catch (error) {
      console.log(error);
    }
  };

  const onSizeGuideChange = (value: any) => {
    try {
      const guideSelect = SizeGuides?.find((guide: any) => {
        return guide.Id === parseInt(value);
      });

      if (guideSelect) {
        // setSizeGuideSelected(guideSelect);
        // setSizeGuideType(guideSelect.TypeSizeGuide);
        // setSizeGuideGender(guideSelect.Gender);

        setSizesGuideSelect(
          guideSelect.Sizes.map((element: any) => {
            return {
              name: element.Name,
              code: element.Id,
            };
          })
        );
      } else {
        // setSizeGuideSelected(null);
        // setSizeGuideType(null);
        // setSizeGuideGender(null);
        setSizesGuideSelect([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePlatformCategoryNameChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (e && e.target) {
      setEditedPlatformCategoryName(e.target.value);
    } else {
      console.log("Event or target is undefined");
    }
  };

  const handleSizeGuideNameChange = (e: any) => {
    setEditedSizeGuideName(e.target.value);
  };

  const handleInputChange = (e: any) => {
    console.log("error", e);
    const { name, value } = e;
    setEditedData({
      ...editedData,
      [name]: value,
    });
  };

  const onClickCancelar = () => {
    navigate(-1);
  };

  const handleVariantsIdChange = (e: any) => {
    setEditedVariantsId(e.target.value);
  };

  const renderCodeInput = () => {
    return (
      <div className="product-edit-column">
        <InputTextForm
          Label={intl.formatMessage({
            id: "ready-size-model",
            defaultMessage: "Modelo:",
          })}
          Placeholder={intl.formatMessage({
            id: "product-edit-enter-guide-name",
            defaultMessage: "Ingresar el nombre de la guía",
          })}
          MaxLength={25}
          DefaultValue={editedData.Code}
          SuscribedChange={(value: any) =>
            handleInputChange({ value: value, name: "Code" })
          }
        />

        {/* <label htmlFor="code">Code:</label>
        <input
          type="text"
          id="code"
          name="Code"
          value={editedData.Code}
          onChange={handleInputChange}
        /> */}
      </div>
    );
  };

  const contentAlias = () => {
    return (
      <>
        <div className="productedit-contentalias-container">
          <div>
            <div
              ref={divRef}
              onPaste={handlePaste}
              onClick={handleClick}
              className={`editsizeguide-alias-cp ${isClicked ? "clicked" : ""}`}
            >
              <FormattedMessage
                id="ready-size-paste"
                defaultMessage="Pega aquí tus alias"
              />
            </div>
            <p>
              <FormattedMessage
                id="ready-size-search-buscar"
                defaultMessage="Buscar"
              />
            </p>
            <input
              type="text"
              placeholder="Ej: Guia-Superior-Masculino"
              className="editsizeguide-custom-alias-input"
              value={inputValue}
              onChange={handleInputsChange}
            />
          </div>
          <div
            className="tag-container"
            style={{ maxHeight: "400px", overflowY: "auto" }}
          >
            {renderInputs()}
          </div>
        </div>
      </>
    );
  };

  const renderVariantsIdInput = () => {
    return (
      <div className="product-edit-column">
        {/* <ChipsControl
          Title={"SKU"}
          Placeholder={"Ingresar el nombre de la guía"}
          MaxLength={25}
          DefaultValue={editedVariantsId}
          SuscribedChange={handleVariantsIdChange}
        /> */}
        {/* <InputTextForm
          Label={"SKU:"}
          Placeholder={"Ingresar el nombre de la guía"}
          MaxLength={25}
          DefaultValue={editedVariantsId}
          SuscribedChange={handleVariantsIdChange}
        /> */}
        {/* <label htmlFor="variantsId">SKU</label>
        <input
          type="text"
          id="variantsId"
          name="variantsId"
          value={editedVariantsId}
          onChange={handleVariantsIdChange}
        /> */}
      </div>
    );
  };

  const renderDescriptionInput = () => {
    return (
      <div className="product-edit-column">
        <InputTextForm
          Label={intl.formatMessage({
            id: "ready-size-description",
            defaultMessage: "Descripción:",
          })}
          Placeholder={intl.formatMessage({
            id: "product-edit-enter-guide-name",
            defaultMessage: "Ingresar el nombre de la guía",
          })}
          // Label={"Descripción:"}
          // Placeholder={"Ingresar el nombre de la guía"}
          MaxLength={25}
          DefaultValue={editedData.Description}
          SuscribedChange={(value: string) => handleInputChange(value)}
        />
        {/* <label htmlFor="description">Descripción:</label>
        <input
          type="text"
          id="description"
          name="Description"
          value={editedData.Description}
          onChange={handleInputChange}
        /> */}
      </div>
    );
  };

  const renderBodyAreaInputs = () => {
    return (
      <div className="product-edit-column">
        <SelectBodyArea
          Label={intl.formatMessage({
            id: "ready-size-position",
            defaultMessage: "Posición:",
          })}
          // Label={indice === 0 ? "Posición" : ""}
          DefaultValue={editedData["BodyArea.Name"]}
          // DefaultValue={elemento.BodyArea?.Id}
          SuscribedChange={handleInputChange}
          // SuscribedChange={(e: any) =>
          //   onProductBodyAreaChange(indice, e, elemento)
          // }
        />
        {/* <label htmlFor="bodyArea">Body Area:</label>
        <select
          id="bodyArea"
          name="BodyArea.Name"
          value={editedData["BodyArea.Name"]} // Update the value attribute
          onChange={handleInputChange}
        >
          <option value="superior">Superior</option>
          <option value="inferior">Inferior</option>
        </select> */}
      </div>
    );
  };

  const renderGenderInputs = () => {
    return (
      <div className="product-edit-column">
        <SelectGenders
          Label="ready-size-gender"
          // Label={"Género"}
          // Label={indice === 0 ? "Género" : ""}
          DefaultValue={editedData["Gender.Name"]}
          // DefaultValue={elemento.Gender?.Id}
          SuscribedChange={handleInputChange}
          // SuscribedChange={(e: any) =>
          //   onProductGenderChange(indice, e, elemento)
          // }
        />
        {/* <label htmlFor="gender">Gender:</label>
        <select
          id="gender"
          name="Gender.Name"
          value={editedData["Gender.Name"]} // Update the value attribute
          onChange={handleInputChange}
        >
          <option value="female">Female</option>
          <option value="male">Male</option>
        </select> */}
      </div>
    );
  };

  const renderTalles = () => {
    return (
      <div className="product-edit-column">
        <p className="product-edit-label-asd">
          <FormattedMessage id="ready-size-sizes" />
        </p>
        <MultiselectDropdownForm
          optionLabel=""
          SelectedValues={selectedSizes}
          Options={SizesGuideSelect}
          Placeholder="products-form-select-sizes"
          // Placeholder={"Seleccionar talles"}
          SuscribedChange={onSizesChange}
        />
      </div>
    );
  };

  const renderFitTypeInput = () => {
    return (
      <div className="product-edit-column">
        <SelectFitType
          Label="Fit"
          // Label={indice === 0 ? "Fit" : ""}
          DefaultValue={editedData["FitType.Name"]}
          // DefaultValue={elemento.Fit?.Id}
          SuscribedChange={handleInputChange}
          // SuscribedChange={(e: any) => onProductFitChange(indice, e, elemento)}
        />
        {/* <label htmlFor="fitType">Fit Type:</label>
        <select
          id="fitType"
          name="FitType.Name"
          value={editedData["FitType.Name"]}
          onChange={handleInputChange}
        >
          <option value="Regular">Regular</option>
          <option value="Ajustado">Ajustado</option>
          <option value="Holgado">Holgado</option>
        </select> */}
      </div>
    );
  };

  // const renderPlatformCategoryNameInput = () => {
  //   return (
  //     <div className="product-edit-column">
  //       <InputTextForm
  //         Label={intl.formatMessage({
  //           id: "readysize-category-dots",
  //           defaultMessage: "Categoria:",
  //         })}
  //         Placeholder={intl.formatMessage({
  //           id: "product-edit-enter-category-name",
  //           defaultMessage: "Ingresar el nombre de la Categoria",
  //         })}
  //         // Label={"Categoria:"}
  //         // Placeholder={"Ingresar el nombre de la Categoria"}
  //         MaxLength={25}
  //         DefaultValue={editedPlatformCategoryName}
  //         SuscribedChange={handlePlatformCategoryNameChange}
  //       />
  //     </div>
  //   );
  // };

  const renderSizeGuideNameInput = () => {
    return (
      <div className="product-edit-column">
        <SelectDropdownForm
          Elements={SizeGuides}
          IsLoading={isLoadingSizeGuides}
          Label="products-form-selectguide"
          // Label={"Selecciona una guía"}
          Classname={"products-form-dashboard-modal-select"}
          AriaLabel={"Default select example"}
          OptionDefault={true}
          SuscribedChange={onSizeGuideChange}
        />
        {/* <InputTextForm
          Label={"Guia:"}
          Placeholder={"Ingresar el nombre de la guía"}
          MaxLength={25}
          DefaultValue={editedSizeGuideName}
          SuscribedChange={handleSizeGuideNameChange}
        /> */}
        {/* <label htmlFor="sizeGuideName">Guia:</label>
        <input
          type="text"
          id="sizeGuideName"
          name="sizeGuideName"
          value={editedSizeGuideName}
          onChange={handleSizeGuideNameChange}
        /> */}
      </div>
    );
  };

  // Render more functions for other nested properties as needed

  return (
    <div>
      <div className="productedit-suggestion-widget-container">
        <div className="productedit-suggestion-widget">
          <SuggestionWidget
            title={
              <FormattedMessage
                id="product-registration-widget-title"
                defaultMessage="Importante"
              />
            }
            description={
              <FormattedMessage
                id="product-registration-widget-description"
                defaultMessage="Completar el <b>Modelo</b> es obligatorio y debe coincidir con el que utilizan en la página de e-commerce. \n\n Si no cuentas con códigos de modelo, debes crearlo."
                values={{
                  b: (...chunks: ReactNode[]) => <b>{chunks}</b>,
                  br: <br />,
                }}
              />
            }
          />
        </div>
        <div className="productedit-suggestion-widget-right">
          <SuggestionWidget
            title={
              <FormattedMessage
                id="product-registration-widget-title"
                defaultMessage="Importante"
              />
            }
            description={
              <FormattedMessage
                id="product-registration-widget-description-two"
                defaultMessage="Al crear un Modelo, puedes utilizar las <b>primeras cifras de los SKUs</b> (como se muestra en el ejemplo.) Luego, cuando asocies una guía de talle al Modelo, se asignará a todos los SKUS automáticamente"
                values={{
                  b: (...chunks: ReactNode[]) => <b>{chunks}</b>,
                  br: <br />,
                }}
              />
            }
          />
        </div>
      </div>
      <div className="edit-product-grid-container">
        <div className="product-image-container">
          <img
            src="img/readysizelogo.png"
            alt="rslogo"
            className="ms-product-img"
          />
        </div>
        <div className="product-edit-col">
          <div className="product-edit-model-container">
            {renderCodeInput()}
          </div>
          <div className="product-edit-description-container">
            {renderDescriptionInput()}
          </div>
          <div className="product-edit-genderposition-container">
            {renderGenderInputs()}
            {renderBodyAreaInputs()}
          </div>
          <div className="product-edit-guidesizes-container">
            {renderSizeGuideNameInput()}
            {renderTalles()}
          </div>
          <div>{renderFitTypeInput()}</div>
          {/* {renderVariantsIdInput()} */}
        </div>
      </div>
      <div className="product-edit-alias-container">
        <Row className="mt-4">
          <Col>
            <p className="font-fitprenda-title-crud">
              <FormattedMessage
                id="ready-size-edit-size-guide-other-codes"
                defaultMessage="Agregar otras codificaciónes"
              />
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="font-fitprenda-subtitle-crud">
            <p>
              <FormattedMessage
                id="ready-size-edit-size-guide-other-codes-exp"
                defaultMessage="Ingresa en cada campo las {boldText} de la siguiente forma: desde - hasta."
                values={{
                  boldText: (
                    <b>
                      <FormattedMessage
                        id="edit-size-guide-bodyMeasurements"
                        defaultMessage="medidas corporales"
                      />
                    </b>
                  ),
                }}
              />
            </p>
            <TooltipAlias />
            {/* <Tooltip
            headingId="tooltip.heading2"
            paragraphIds={["tooltip.paragraph3", "tooltip.paragraph4"]}
            firstParagraphBackgroundColor="#8e5cf1"
            tooltipRight="-300px" // custom value
            tooltipWidth="300px" // custom value
            tooltipTop="-70px" // custom value
          /> */}
          </Col>
        </Row>
        <Row className="contentalias-container">
          {/* Componente de Talles Contornos y alto total */}
          <Col>
            <BlockContentControls paddingX={5} children={contentAlias()} />
          </Col>
        </Row>
      </div>
      <Row className="mt-3 productedit-buttons-container">
        <Col xs={1} className="edit-size-guide-button">
          <ButtonCommon
            label={
              <FormattedMessage
                id="ready-size-Cancelar"
                // defaultMessage="Cancelar"
              />
            }
            isOutline={true}
            eventClick={() => onClickCancelar()}
            className="edit-size-guide-button"
          />
        </Col>
        <Col xs={1} className="edit-size-guide-button">
          <ButtonCommon
            label={
              <FormattedMessage
                id="ready-size-Guardar"
                defaultMessage="Guardar"
              />
            }
            isOutline={false}
            // eventClick={() => onClickSave()}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ProductEdit;
